import { createContext, ReactNode } from 'react';
import { createTheme, ThemeProvider as MuiProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useLanguage } from 'core/localization/hooks';
import { ThemeTypes } from '../entities';
import { getTheme } from '../utils/getTheme';

export const ThemeContext = createContext<ThemeTypes>(ThemeTypes.DEFAULT);

type ThemeProviderProps = {
  children?: ReactNode;
  themeType?: ThemeTypes;
};

const ThemeProvider = ({ children, themeType = ThemeTypes.DEFAULT }: ThemeProviderProps) => {
  const theme = getTheme(themeType);
  const { dir } = useLanguage();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  const themeMUI = createTheme({
    ...theme,
    direction: dir,
  });

  return (
    <ThemeContext.Provider value={themeType}>
      <MuiProvider theme={themeMUI}>
        <StyledThemeProvider theme={themeMUI}>{children}</StyledThemeProvider>
      </MuiProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
